module.exports = __webpack_public_path__ + "fonts/Renault-Global.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/fonts/icons/Renault-Global.svg
// module id = 370
// module chunks = 0